import React, { useCallback, useState } from 'react'
import { CLASS_PREFIX } from 'src/constants'
import { ProjectsLearnMoreModal } from '../learn_more/projects_learn_more_modal'
import { ProjectsCreateModal } from '../project_create/projects_create_modal'
import { ProjectsCreateSuccessModal } from '../project_create/projects_create_success_modal'
import { ProjectListHeader } from '../project_list_header/project_list_header'
import { ProjectListEmptyState } from './project_list_empty_state'
import { ProjectListErrorState } from './project_list_error_state'

import { ProjectType, useGlobalPermissions } from '@lopo-tech/lopo-api'
import { getProjectRoutes } from 'src/constants/urls'
import './project_list_wrapper.scss'

const cls = `${CLASS_PREFIX}project-list-wrapper`

type Props = {
  showErrorState: boolean;
  showEmptyState: boolean;
  refetch: () => void;
  projectType: ProjectType;
};

export const ProjectListWrapper: React.FC<Props> = ({
  showErrorState,
  showEmptyState,
  refetch,
  projectType,
  children
}) => {
  const [isCreateProjectOpen, setIsCreateProjectOpen] = useState(false)
  const [isCreateSuccessOpen, setIsCreateSuccessOpen] = useState(false)
  const [isLearnOpen, setIsLearnOpen] = useState(false)
  const [newProjectSlug, setNewProjectSlug] = useState('')
  const { canCreatePublicParticipationProject } = useGlobalPermissions()
  const routes = getProjectRoutes(projectType)

  const openCreateProject = useCallback(() => {
    setIsCreateProjectOpen(true)
  }, [])

  return (
    <div className={cls}>
      <div className={`${cls}__wrapper`}>
        {projectType === ProjectType.PublicParticipationProject && (
          <ProjectListHeader
            openCreateProject={
              canCreatePublicParticipationProject
                ? openCreateProject
                : undefined
            }
            openLearnMore={() => setIsLearnOpen(true)}
          />
        )}
        {showErrorState && <ProjectListErrorState onRetry={refetch} />}
        {showEmptyState && (
          <ProjectListEmptyState
            openCreateProject={
              canCreatePublicParticipationProject
                ? openCreateProject
                : undefined
            }
          />
        )}
        {children}
        {projectType === ProjectType.PublicParticipationProject && (<>
          {isCreateProjectOpen && (
            <ProjectsCreateModal
              onCancel={() => setIsCreateProjectOpen(false)}
              onNext={(projectSlug?: string) => {
                setNewProjectSlug(projectSlug || '')
                setIsCreateProjectOpen(false)
                setIsCreateSuccessOpen(true)
              }}
            />
          )}
          {/* Success dialog */}
          {isCreateSuccessOpen && (
            <ProjectsCreateSuccessModal
              projectHref={
                newProjectSlug ? routes.detail(newProjectSlug) : undefined
              }
              onClose={() => {
                setNewProjectSlug('')
                setIsCreateSuccessOpen(false)
              }}
            />
          )}
          {isLearnOpen && (
            <ProjectsLearnMoreModal
              openCreateProject={
                canCreatePublicParticipationProject
                  ? openCreateProject
                  : undefined
              }
              onClose={() => setIsLearnOpen(false)}
            />
          )}
        </>)}
      </div>
    </div>
  )
}
